import React, { useEffect, useContext } from 'react';
import { useHighlightOfferAndPromotedExperiment } from 'src/hooks/experiments';

import { AppContext } from '@prisjakt/ui-app-context';
import { IProductNativeAdExperimentProps, IExperimentProps } from './types';

const HighlightedAndPromotedExperiment: React.FC<IProductNativeAdExperimentProps> = props => {
  const tabletCategoryId = '1594';
  const { market } = useContext(AppContext);

  return market.code === 'gb' || props.categoryId === tabletCategoryId ? (
    <Experiment setShowHighlightedOffers={props.setShowHighlightedOffers} />
  ) : null;
};

const Experiment: React.FC<IExperimentProps> = props => {
  const experiment = useHighlightOfferAndPromotedExperiment();

  useEffect(() => {
    props.setShowHighlightedOffers(experiment);
  }, [experiment, props]);

  return null;
};

export default HighlightedAndPromotedExperiment;
